module.exports = __webpack_public_path__ + "static/media/colibri.077e8c68.svg";